import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UserSidebar from "../../Component/UserSidebar";
import { Tooltip, Button, OverlayTrigger, Table, Row, Col, Card } from "react-bootstrap";
import Paginate from '../../Component/Paginate';
import queryString from "query-string";
import { loadCertificates } from "./Slice/certificateSlice";
import PropTypes from "prop-types";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

const Index = (props) => {

  const { title } = props;
  const { certificateData, pagination } = useSelector((state) => state?.certificate);
  const userInfo = useSelector((state) => state?.userInfo);

  const location = useLocation();
  const history = useNavigate();
  const dispatch = useDispatch();

  // fetch certificates with user_id + query params
  useEffect(() => {
    if (!userInfo?.id) return;

    const parsed = queryString.parse(location.search);
    const request = { user_id: userInfo.id };

    if (parsed.sort) {
      request.sort = parsed.sort;
      request.direction = parsed.direction;
    }
    if (parsed.page) request.page = parsed.page;
    if (parsed.keyword) request.keyword = parsed.keyword;
    if (parsed.from) request.from = parsed.from;
    if (parsed.to) request.to = parsed.to;

    dispatch(loadCertificates(request));
  }, [dispatch, userInfo, location]);

  useEffect(() => {
    document.title = title;
  }, [title]);

  const handlePageClick = (data) => {
    let page = data + 1;
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    history({
      pathname: "/certificate",
      search: "?" + params.toString(),
    });
  };

  const handleFromDateChange = (e) => {
    const params = new URLSearchParams(location.search);
    if (e.target.value) {
      params.set("from", e.target.value);
    } else {
      params.delete("from");
    }
    params.set("page", "1");
    history({
      pathname: "/certificate",
      search: params.toString() ? "?" + params.toString() : ""
    });
  };

  const handleToDateChange = (e) => {
    const params = new URLSearchParams(location.search);
    if (e.target.value) {
      params.set("to", e.target.value);
    } else {
      params.delete("to");
    }
    params.set("page", "1");
    history({
      pathname: "/certificate",
      search: params.toString() ? "?" + params.toString() : ""
    });
  };

  const handleSearch = () => {
    const params = new URLSearchParams(location.search);
    params.set("page", "1");
    history({
      pathname: "/certificate",
      search: params.toString() ? "?" + params.toString() : ""
    });
  };

  const handleReset = () => {
    history({
      pathname: "/certificate",
      search: "?page=1"
    });
  };

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h1 className="dash_heading">Certificate</h1>
          <Row className="pt-4">
            <Col md={12}>
              <Card className="shadow-sm border-0">
                <Card.Body className="py-4">
                  <Row className="align-items-xl-end g-3">
                    {/* From Date */}
                    <Col md={3} sm={3}>
                      <input
                        type="date"
                        className="form-control"
                        style={{
                          borderRadius: '8px',
                          border: '1px solid #e0e0e0',
                          padding: '8px 12px',
                          fontSize: '14px'
                        }}
                        placeholder="From"
                        value={new URLSearchParams(location.search).get("from") || ""}
                        onChange={handleFromDateChange}
                      />
                    </Col>
                    {/* To Date */}
                    <Col md={3} sm={3}>
                      <div>
                        <input
                          type="date"
                          className="form-control"
                          style={{
                            borderRadius: '8px',
                            border: '1px solid #e0e0e0',
                            padding: '8px 12px',
                            fontSize: '14px'
                          }}
                          value={new URLSearchParams(location.search).get("to") || ""}
                          onChange={handleToDateChange}
                        />
                      </div>
                    </Col>
                    <Col md={3} sm={3}>
                    <div className="d-flex g-3">
                      <Button
                      className="btn loginsubmit outline"
                        // variant="primary"
                        onClick={handleSearch}
                      >
                        <i className="fas fa-search"></i>
                      </Button>
                      <Button
                        // variant="primary"
                        className="btn loginsubmit outline ms-3"
                        onClick={handleReset}
                        // className="ms-3"
                      >
                        <i className="fas fa-sync-alt"></i>
                      </Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col>
              <Card>
                <Card.Body>
                  <Paginate
                    pagination={pagination}
                    onClick={handlePageClick}
                  />
                  {certificateData?.length > 0 ?
                    <Table striped responsive>
                      <thead >
                        <tr>
                          <th>Engaged with</th>
                          <th>Special certificate</th>
                          <th>Accept date</th>
                          <th>Session end</th>
                          <th>Created at</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {certificateData?.map((item, ind) =>
                          <tr key={item.id}>
                            <td scope="row">
                              {item?.user_data?.role_id === 'Mentees' ? item?.mentor_data
                                ?.full_name : item?.mentee_data?.full_name}
                            </td>
                            <td scope="row">
                              {item.is_special_certificate ? 'Yes' : 'No'}
                            </td>
                            <td scope="row">
                              {item.accept_date}
                            </td>
                            <td scope="row">
                              {item.session_end_date}
                            </td>
                            <td scope="row">
                              {item.created_at}
                            </td>
                            <td scope="row">
                              <OverlayTrigger overlay={<Tooltip> Download</Tooltip>}>
                                <Button
                                  variant="warning py-1 px-2"
                                  href={item.cert_file} target="_blank"
                                >
                                  <i className="fas fa-download mr-0"></i>
                                </Button>
                              </OverlayTrigger>
                            </td>
                          </tr>)}
                      </tbody>
                    </Table>
                    : <div className="text-center">No certificate found</div>}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default Index;
